
import { NgModule, Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ]
})
export class SharedModule { }
